export default __webpack_public_path__ + "static/media/BrandocVillageEast.acce66b9.jpg";